import { Component, Input } from '@angular/core';

import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

@Component({
	selector: 'app-spinner',
	templateUrl: 'spinner.component.html',
	styleUrls: ['spinner.component.scss']
})
export class SpinnerComponent {
	spinnerIcon = faSpinnerThird;

	@Input()
	message: string;

	@Input()
	class: string = '';
}
